import { Page } from '../views/Page';
import { UnderDevelopment } from '../../support';

export const UnderDevelopmentPage: React.FC<any> = (props: any) => {
  const {
    title,
  } = props;
  return <Page title={title}>
    <UnderDevelopment />
  </Page>;
};
